import { Route, Routes } from "react-router-dom";

import Objectives from "./Objectives";

function ObjectivesApp() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Objectives />} />
      </Routes>
      {/**/}
    </div>
  );
}

export default ObjectivesApp;
